import { SocketEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

/**
 * get profile using method GET /profile
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getSocketToken = async (): Promise<any> =>
    APIManager.sendGet(SocketEnds.SOCKET_TOKEN, true, {}, {}, axios);

export const SocketService = {
    getSocketToken,
};
